<template>
  <SimpleDataWithVariation
    :title="title"
    :item-id="itemId"
    :value="value"
    :variation="variation"
    :raw-variation="rawVariation"
    :request-status="requestStatus"
    :comparation-value="comparationValue"
    v-bind="$attrs"
    class="make-a-copy"
    @reload="getData"
  />
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { formatSocialNumberWithDecimal } from '@/utils/formatter';
import SimpleDataWithVariation from './models/SimpleDataWithVariation.vue';
import sacListeningModel from '@/mixins/sac-listening-model';
import EventBus from '@/utils/event-bus';

export default {
  name: 'OwnedEarnedUniquePostReach',
  components: {
    SimpleDataWithVariation,
  },
  mixins: [
    sacListeningModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      showGlobalFilterModal: false,
      filterButton: this.$t('components.OperatorsLogs.filterLabel'),
      value: '',
      variation: '',
      rawVariation: '',
      comparationValue: '',
    };
  },
  computed: {
    ...mapGetters('filter', [
      'formattedDateRange',
    ]),
    ...mapGetters('dashboard', [
      'activeDashboardFilters',
      'activeDashboard',
      'activeGlobalFilter',
    ]),
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getSeStudioEndpointService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }
      const card = this.activeDashboard.data.cards.find(card => card.id === this.itemId);
      this.getSeStudioEndpointService({
        itemId: this.itemId,
        servicePath: 'countPosts',
        serviceParams: {
          filterId: card.props.sacFilterId || card.props.filterId,
          dateRange: this.formattedDateRange,
        },
      })
        .then(response => {
          this.value = response.currentTotalPostsListening + response.currentTotalPostsSac;
          this.variation = response.totalPostsVariation;
          this.rawVariation = response.totalPostsVariation;
          this.comparationValue = formatSocialNumberWithDecimal(response.previousTotalPostsListening + response.previousTotalPostsSac);
          this.requestStatus = 'success';
          if (this.$attrs.filter) {
            this.filter = this.$attrs.filter;
          }

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
